// Simulação de frete e previsão de entrega.
// A data base é sempre a do navegador de quem acessa, então a previsão
// acompanha o dia da visita mesmo com a página em cache.

{
  const MESES = [
    'janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho',
    'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro',
  ];

  // Soma dias corridos ou apenas úteis, pulando sábado e domingo
  function somarDias(base, dias, apenasUteis) {
    const data = new Date(base.getTime());
    if (!apenasUteis) {
      data.setDate(data.getDate() + dias);
      return data;
    }
    let restantes = dias;
    while (restantes > 0) {
      data.setDate(data.getDate() + 1);
      const semana = data.getDay();
      if (semana !== 0 && semana !== 6) restantes -= 1;
    }
    return data;
  }

  class MaEntrega extends HTMLElement {
    connectedCallback() {
      const alvo = this.querySelector('[data-prazo]');
      if (!alvo) return;

      const min = parseInt(this.dataset.min, 10) || 0;
      const max = parseInt(this.dataset.max, 10) || min;
      const uteis = this.dataset.uteis === 'true';

      const hoje = new Date();
      const inicio = somarDias(hoje, min, uteis);
      const fim = somarDias(hoje, max, uteis);

      alvo.textContent = this.formatar(inicio, fim);
    }

    // "17 e 24 de agosto" quando o mês é o mesmo; "28 de agosto e 3 de setembro" quando muda
    formatar(inicio, fim) {
      const d1 = inicio.getDate();
      const d2 = fim.getDate();
      const m1 = MESES[inicio.getMonth()];
      const m2 = MESES[fim.getMonth()];

      if (inicio.getTime() === fim.getTime()) return `${d1} de ${m1}`;
      if (m1 === m2) return `${d1} e ${d2} de ${m1}`;
      return `${d1} de ${m1} e ${d2} de ${m2}`;
    }
  }

  if (!customElements.get('ma-entrega')) customElements.define('ma-entrega', MaEntrega);

  class MaFrete extends HTMLElement {
    connectedCallback() {
      this.campo = this.querySelector('[data-cep]');
      this.botao = this.querySelector('[data-calcular]');
      this.lista = this.querySelector('[data-lista]');
      this.erro = this.querySelector('[data-erro]');
      if (!this.campo || !this.botao) return;

      this.campo.addEventListener('input', () => this.mascarar());
      this.campo.addEventListener('keydown', (evento) => {
        if (evento.key === 'Enter') {
          evento.preventDefault();
          this.calcular();
        }
      });
      this.botao.addEventListener('click', () => this.calcular());
    }

    // 71937720 -> 71937-720
    mascarar() {
      const digitos = this.campo.value.replace(/\D/g, '').slice(0, 8);
      this.campo.value = digitos.length > 5 ? `${digitos.slice(0, 5)}-${digitos.slice(5)}` : digitos;
      if (this.erro) this.erro.hidden = true;
    }

    calcular() {
      const digitos = this.campo.value.replace(/\D/g, '');
      const valido = digitos.length === 8;

      if (this.erro) this.erro.hidden = valido;
      if (this.lista) this.lista.hidden = !valido;

      if (!valido) {
        this.campo.focus();
        return;
      }
      this.botao.setAttribute('aria-expanded', 'true');
    }
  }

  if (!customElements.get('ma-frete')) customElements.define('ma-frete', MaFrete);
}
